import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

/**
 * AvatarGroup is a helper component for Avatar.
 * @group Components
 */
const _c0 = ["*"];
let AvatarGroup = /*#__PURE__*/(() => {
  class AvatarGroup {
    /**
     * Style class of the component
     * @group Props
     */
    styleClass;
    /**
     * Inline style of the component.
     * @group Props
     */
    style;
    static ɵfac = function AvatarGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AvatarGroup)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AvatarGroup,
      selectors: [["p-avatarGroup"]],
      hostAttrs: [1, "p-element"],
      inputs: {
        styleClass: "styleClass",
        style: "style"
      },
      ngContentSelectors: _c0,
      decls: 2,
      vars: 4,
      consts: [[3, "ngClass", "ngStyle"]],
      template: function AvatarGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.styleClass);
          i0.ɵɵproperty("ngClass", "p-avatar-group p-component")("ngStyle", ctx.style);
        }
      },
      dependencies: [i1.NgClass, i1.NgStyle],
      styles: ["@layer primeng{.p-avatar-group p-avatar+p-avatar{margin-left:-1rem}.p-avatar-group{display:flex;align-items:center}}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return AvatarGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AvatarGroupModule = /*#__PURE__*/(() => {
  class AvatarGroupModule {
    static ɵfac = function AvatarGroupModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AvatarGroupModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AvatarGroupModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
  return AvatarGroupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AvatarGroup, AvatarGroupModule };
